import { bool } from 'prop-types'
import { useEffect } from 'react'
import CountUp from 'react-countup'
import { useSelector } from 'react-redux'

import styles from './search-results-toolbar.module.scss'
import { SortByDropdown } from '@/components/atomic/SortByDropdown'
import { SaveTrigger } from '@/components/search/saved-search/SaveTrigger'
import { Button, ButtonHierarchy } from '@/components/styleguide/Button'
import { constants } from '@/lib/constants'
import { setWithExpiry, storageAvailable } from '@/lib/utilities/system'
import { addToDataLayer } from '@/lib/utilities/vehicle'
import { selectPricesTotal } from '@/store/selectors/search'
import { Size } from '@/types/system'

export const SearchResultsToolbar = ({ layoutType, setLayoutType, isVans = false }) => {
  const pricesTotal = useSelector(selectPricesTotal)

  useEffect(() => {
    // adds default layoutType to DL
    addToDataLayer({
      browseLayout: layoutType,
    })
  }, [layoutType])

  const handleLayoutChange = newLayoutType => {
    setLayoutType(newLayoutType)

    if (storageAvailable('localStorage')) {
      const twoWeeks = 1209600000
      setWithExpiry(constants.localStorageKey.browseLayoutType, newLayoutType, twoWeeks)
    }

    // updates layout in DL
    addToDataLayer({
      browseLayout: newLayoutType,
    })
  }

  return (
    <div className={styles.main}>
      <div className={styles['deal-count']}>
        <p className={styles.label}>Showing</p>
        <p className={styles.count}>
          <CountUp
            start={0}
            end={pricesTotal}
            separator=","
            delay={0}
            useEasing={true}>
            {({ countUpRef }) => (
              <>
                <span ref={countUpRef} />
              </>
            )}
          </CountUp>
          <span className={styles.type}>{isVans ? ' Van ' : ' Car '}leasing</span> deals
        </p>
      </div>
      <div className={styles['save-search-container']}>
        <SaveTrigger />
      </div>
      <div className={styles.filters}>
        <div className={styles.layouts}>
          <Button
            className={layoutType === 'grid' ? styles.inactive : ''}
            size={Size.Medium}
            hierarchy={ButtonHierarchy.BezeledGray}
            onClick={() => handleLayoutChange('list')}
            icon={'List'}
            hasBackground={false}
          />
          <Button
            className={layoutType === 'list' || !layoutType ? styles.inactive : ''}
            size={Size.Medium}
            hierarchy={ButtonHierarchy.BezeledGray}
            onClick={() => handleLayoutChange('grid')}
            icon={'Grip'}
            hasBackground={false}
          />
        </div>
        <SortByDropdown />
      </div>
    </div>
  )
}

SearchResultsToolbar.propTypes = {
  isVans: bool.isRequired,
}
